import useAuth from '../hooks/useAuth';
import profile from '../pages/profile.svg';

function UserCard() {
  const { getSession } = useAuth();
  const { getProfileAvatar } = useAuth();
  const user = getSession();
  const aI = getProfileAvatar();
  return (
    <>
      <div className="card mb-4">
        <div className="card-body text-center">
          {aI ? <img src={`data:image/png;base64,${aI}`} alt="avatar"
                     className="rounded-circle img-fluid" style={{ width: '150px' }}/>
            : <img src={ profile } alt="avatar"
                 className="rounded-circle img-fluid" style={{ width: '150px' }} />
          }

          <div className="row mt-3">
            <h5 className="mb-0">{user.FULL_NAME}</h5>
          </div>
          <div className="row mt-3">
            <div>
              <h6 className="text-muted mb-0">Member ID: <span>{user.MEMBER_ID}</span></h6>
            </div>
          </div>
          <div className="row mt-3">
            <div>
              <h6 className="text-muted mb-0">Birth Date: <span>{user.DATE_OF_BIRTH}</span></h6>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UserCard;
